import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";

import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import { Box, IconButton, Popover, Slider } from "@mui/material";

const OmniTextToSpeechPlayer = props => {
  const { textToSpeechQueue, setTextToSpeechQueue, volume, setVolume } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const audioRef = useRef(new Audio());
  const isPlayingRef = useRef(false);

  useEffect(() => {
    const audio = audioRef.current;
    audio.volume = volume;
    audio.loop = false;

    const playNextTrack = () => {
      if (textToSpeechQueue.length === 0) {
        isPlayingRef.current = false;
        return;
      }

      isPlayingRef.current = true;
      const [currentTrack, ...rest] = textToSpeechQueue;
      audio.src = currentTrack;
      audio.play().catch(error => {
        console.error("Error playing audio:", error);
        isPlayingRef.current = false;
        setTextToSpeechQueue(rest);
      });

      audio.onended = () => {
        setTextToSpeechQueue(rest);
        isPlayingRef.current = false;
        playNextTrack();
      };
    };

    if (!isPlayingRef.current && textToSpeechQueue.length > 0) {
      playNextTrack();
    }

    return () => {
      audio.pause();
      audio.src = "";
      audio.onended = null;
    };
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textToSpeechQueue, setTextToSpeechQueue]);

  useEffect(() => {
    audioRef.current.volume = volume;
  }, [volume]);

  const handleVolumeButtonClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleSliderChange = (e, newValue) => {
    setVolume(newValue);
  };

  const handleSliderChangeCommitted = () => {
    setAnchorEl(null);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "volume-slider-popover" : undefined;

  return (
    <Box>
      <IconButton
        onClick={handleVolumeButtonClick}
        size="small"
        edge="start"
        color="inherit"
        id="omni-primary-volume-button"
        aria-label="volume control"
        className="ohVolumeControlButton"
        ohVolumeControlButton
        style={{
          maxHeight: 24,
          maxWidth: 24,
          padding: 4,
          margin: 4,
        }}
      >
        {volume === 0 ? <VolumeOffIcon fontSize="small" /> : <VolumeUpIcon fontSize="small" />}
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        slotProps={{
          paper: {
            sx: {
              marginBottom: "96px",
              paddingTop: "16px",
              paddingBottom: "16px",
              paddingLeft: "8px",
              paddingRight: "8px",
              borderRadius: "21px",
            },
          },
        }}
      >
        <Box
          sx={{
            height: "150px",
            width: "30px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Slider
            orientation="vertical"
            value={volume}
            onChange={handleSliderChange}
            onChangeCommitted={handleSliderChangeCommitted}
            min={0}
            max={1}
            step={0.05}
            aria-labelledby="volume-slider"
            sx={{ height: "90%", margin: "0" }}
            className="ohTTSVolumeSlider"
          />
        </Box>
      </Popover>
    </Box>
  );
};

export default OmniTextToSpeechPlayer;
